import { TarefasRecuperacaoCreditoComponent } from './recuperacao-de-credito/tarefas-recuperacao-de-credito.component';
import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { TarefasRoutingModule } from './tarefas-routing.module';
import { TarefasRelatoriosComponent } from './relatorios/tarefas-relatorios.component';
import { TarefasHonraComponent } from './honra/tarefas-honra.commponent';
import { TarefasOperacaoComponent } from './operacao/tarefas-operacao.component';
import { TarefasSistemaComponent } from './sistema/tarefas-sistema.component';
import { TarefasContratoSccComponent } from './contrato-scc/tarefas-contrato-scc.component';
import { TarefasCobrancaComponent } from './cobranca/tarefas-cobranca.component';
import {  TarefasFgenergiaComponent } from './fgenergia/tarefas-fgenergia.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TarefasProtocoloComponent } from './protocolo/tarefas-protocolo.component';
import { TarefasLimitesComponent } from './limite/tarefas-limites.component';
import { TarefasInadimplenciaComponent } from './inadimplencia/tarefas-inadimplencia.component';
import { TarefasRemuneracaoComponent } from './remuneracao/tarefas-remuneracao.component';
import { TarefasLeilaoComponent } from './leilao/tarefas-leilao.component';



@NgModule({
  imports: [
    SharedModule,
    TarefasRoutingModule,
    ClipboardModule,
  ],
  declarations: [
    TarefasRelatoriosComponent,
    TarefasLimitesComponent,
    TarefasInadimplenciaComponent,
    TarefasOperacaoComponent,
    TarefasHonraComponent,
    TarefasSistemaComponent,
    TarefasProtocoloComponent,
    TarefasRecuperacaoCreditoComponent,
    TarefasCobrancaComponent,
    TarefasContratoSccComponent,
    TarefasFgenergiaComponent,
    TarefasRemuneracaoComponent,
    TarefasLeilaoComponent,
  ]
})
export class TarefasModule { }
